import Bronze from 'src/assets/img/house/bronze.png'
import Silver from 'src/assets/img/house/silver.png'
import Gold from 'src/assets/img/house/gold.png'

export const categories = [
  { id: 0, name: 'All', icon: '背景' },
  { id: 1, name: 'Collection', icon: '壁紙' },
  { id: 2, name: 'Bed', icon: '大' },
  { id: 3, name: 'Table', icon: '中' },
  { id: 4, name: 'Chair', icon: '小' },
  { id: 5, name: 'Male', icon: '彼' },
  { id: 6, name: 'Female', icon: '私' }
]

export const materialCategories = [
  { key: 'background', label: '背景' },
  { key: 'concept', label: '室内' },
  { key: 'large_item', label: '大' },
  { key: 'medium_item', label: '中' },
  { key: 'small_item', label: '小' },
  { key: 'he', label: '彼', source_category: 'character' },
  { key: 'myself', label: '私', source_category: 'user' }
]

export const imageMap = {
  bronze: Bronze,
  silver: Silver,
  gold: Gold
}

export const rankColors = {
  gold: '#FFD700',
  silver: '#C0C0C0',
  bronze: '#CD7F32'
}

export const labelMap = {
  bronze: 'ブロンズ',
  silver: 'シルバー',
  gold: 'ゴールド'
}

export const RANK_UP_PRICE = 70

export const RANK_ORDER = ['bronze', 'silver', 'gold']

export const RANK_IMAGES = {
  bronze: Bronze,
  silver: Silver,
  gold: Gold
}

export const RANK_CONFIGS = [
  {
    rank: 'bronze',
    gridSize: '8×8×5',
    description: '8×8×5の基本スタイル!\nまずはBRONZEでアイプリのHOUSEを楽しもう♪'
  },
  {
    rank: 'silver',
    gridSize: '10×10×5',
    description: '10×10×5の王道スタイル! \n やっぱり自慢のHOUSEは広い方がいいよね♪'
  },
  {
    rank: 'gold',
    gridSize: '12×12×5',
    description: '12×12×5の上級スタイル! \n 超広い自慢のHOUSEに友達たくさん呼んじゃおう♪'
  }
]
